import { useMemo } from "react";
import { AspectRatio } from "@radix-ui/react-aspect-ratio";

import ColorButtonWithTooltip from "../button/color-button-with-tooltip";
import { SafeImage } from "../image/SafeImage";
import { ProductColorVM } from "@/types/product-ui.types";

type PreviewCarouselProps = {
  current: number;
  changeSlideByIndex: (index: number) => void;
  productColors: ProductColorVM[];
};

export function PreviewCarousel({
  current,
  changeSlideByIndex,
  productColors = [],
}: PreviewCarouselProps) {
  const handleSlide = useMemo(() => {
    return (index: number) => {
      changeSlideByIndex(index);
    };
  }, [changeSlideByIndex]);

  const thumbnailColors = useMemo(
    () =>
      productColors.map(({ code, name }, index) => (
        <ColorButtonWithTooltip
          key={name}
          name={name}
          colorCode={code}
          handleColorClick={() => handleSlide(index)}
          isSelected={current === index}
        />
      )),
    [productColors, current, handleSlide]
  );

  return (
    <div className="space-y-4 mb-5">
      <AspectRatio ratio={3 / 4} className="w-full overflow-hidden">
        <SafeImage
          src={productColors[current].images?.[0] || "/product-placeholder.png"}
          alt={`Product color ${current + 1}`}
          className="object-cover w-full h-full group-hover:scale-105 transition-transform"
        />
      </AspectRatio>
      <div className="flex cursor-auto" onClick={(e) => e.preventDefault()}>
        {thumbnailColors}
      </div>
    </div>
  );
}
